import { useState, useRef, useCallback } from 'react';
import { getRelativePosition } from '../util/getRelativePosition';
import { useClickOutside } from './useClickOutside';
import { useDocumentKeydown } from './useDocumentKeydown';
export function useOverlay(edge, align) {
    var _a = useState(false), open = _a[0], setOpen = _a[1];
    var triggerRef = useRef(null);
    var containerRef = useRef(null);
    var overlayStyle = triggerRef.current
        ? getRelativePosition(triggerRef.current.getBoundingClientRect(), edge, align)
        : {};
    useClickOutside(useCallback(function () {
        setOpen(false);
    }, []), [triggerRef, containerRef], open);
    useDocumentKeydown(useCallback(function (e) {
        if (e.key === 'Escape') {
            setOpen(false);
        }
    }, []));
    return {
        open: open,
        setOpen: setOpen,
        triggerRef: triggerRef,
        containerRef: containerRef,
        overlayStyle: overlayStyle,
    };
}
//# sourceMappingURL=useOverlay.js.map